<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
import moment from 'moment';
import statementOfAccount from "./statement-of-account.vue";
import Swal from "sweetalert2";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
let bill = 0;

export default {
    page: {
        title: "View Monthly Statement",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "View Monthly Statement",
            items: [
                {
                text: "View Monthly Statement",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            invoice_details:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,

            name_as_per_nric:'',
            phone_number:'',
            address:'',
            postalcode:'',
            city:'',
            state_name:'',
            invoice_description:'',
            invoice_overpayment: 0,
            invoice_latecharge: 0,
            invoice_amount: 0,
            invoice_number:'',
            invoice_issue_date:'',
            invoice_due_date:'',
            invoice_imei:'',
            invoice_product:'',
            invoice_path: '',
            credit_note: '',
            downloadLoading: false,
            emailLoading: false,

            bill: 0,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getInvoiceDetails(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/invoicesDetailsById/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.invoice_details = response.data;
                    this.name_as_per_nric = this.invoice_details[0].name_as_per_nric;
                    this.phone_number = this.invoice_details[0].phone_number;
                    this.address = this.invoice_details[0].address;
                    this.postalcode = this.invoice_details[0].postalcode;
                    this.city = this.invoice_details[0].city;
                    this.state_name = this.invoice_details[0].state_name;
                    this.invoice_description = this.invoice_details[0].description;
                    this.invoice_amount = this.invoice_details[0].total_amount ?? 0;
                    this.invoice_number = this.invoice_details[0].invoice_no;
                    this.invoice_issue_date = this.invoice_details[ 0].issue_date;
                    this.invoice_due_date = this.invoice_details[0].due_date;
                    this.invoice_imei = this.invoice_details[0].imei;
                    this.invoice_product = this.invoice_details[0].product_name;
                    this.invoice_path = this.invoice_details[0].file_location;
                    this.credit_note = this.invoice_details[0].credits_applied ?? 0;
                    this.invoice_overpayment = this.invoice_details[0].over_pay ?? 0;
                    this.invoice_latecharge = this.invoice_details[0].late_payment_charges ?? 0;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        bil_count(){
            console.log(this.bill);
            bill = bill + 1;
            return bill;
        },

        resetBillCount() {
            bill = 0;
        },

        downloadPDF: function () {
            this.downloadLoading = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/download/' + this.$route.params.id, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${this.invoice_number}.pdf`);
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                    this.loadingDetail=false;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                alert('Something when wrong. Please try again');
                this.messageBag = [error.error];
            })
            .finally(()=>{
                this.downloadLoading = false;
            });
        },

        sendEmail: function(){
            // loading true
            this.emailLoading = true;

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'invoice/notifications/email', {
                invoice_id: this.$route.params.id,
            })
            .then(response => {
                if (response) {                
                    Swal.fire({
                              title:"Invoice sent successfully", 
                              icon:"success",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              this.$router.push('/ar/invoices/invoice-listing');
                            }
                          });
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                Swal.fire({
                    title:"Failed to sent invoice.", 
                    icon:"warning",
                })
                this.messageBag = [error.error];
            })
            .finally(()=>{
                // loading false
                this.emailLoading = false;
            });
        },
    },

    components: {
        Layout,
        PageHeader,
        statementOfAccount,
    },

    mounted() {
        this.getInvoiceDetails();
        this.resetBillCount();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
.card-header {
    padding: 1rem 5rem;
}
.col-width {
    width: 70%; 
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
            <div class="row justify-content-center">
                <div class="col-xxl-8"> 
                    <br><br>
                    <div class="card" id="demo">
                        <div class="card-header border-bottom-dashed" style="border-bottom: 1px solid #cfd3d7;">
                            <div class="d-sm-flex">
                                <div class="col-xl-7">
                                    <img src="@/assets/images/compasiaLogo.png" class="card-logo card-logo-dark" alt="logo dark" height="52">
                                    <img src="@/assets/images/compasiaLogo.png" class="card-logo card-logo-light" alt="logo light" height="52"> <br>
                                </div>
                                <div class="pull-right" style="text-align: right">
                                    <h5>CompAsia Sdn Bhd (1006653-T)</h5>                                  
                                        Wisma Academy, Suite 1.01, Level 1,<br>
                                        4, Jalan 19/1, Seksyen 19,<br>
                                        46300 Petaling Jaya, Selangor<br><br>
                                        support@compasia.com<br>
                                </div>
                            </div>
                        </div>
                        

                        <div class="card-header border-bottom-dashed mt-4" style="border-bottom: 1px solid #cfd3d7;">
                            <div class="d-sm-flex">
                                <div class="col-xl-7">
                                    <h5><span class="fw-normal"><b>BILLING ADDRESS</b></span><br></h5>
                                    
                                    <p class="text-muted fw-normal" id="legal-register-no">{{ name_as_per_nric }}</p>
                                    <p class="text-muted fw-normal" id="legal-register-no">{{ address }}<br>
                                    {{ postalcode }}, {{ city }}<br> 
                                    {{ state_name }}
                                    </p>
                                    <p class="text-muted fw-normal">{{ phone_number }}</p>
                                </div>
                                <div class="col-xl-5">                                   
                                    <div class="row mb-1">
                                        <div class="col-lg-4">
                                            <label for="nameInput" class="form-label">Ref. No</label>
                                        </div>
                                        <div class="col-lg-8 text-muted">
                                        {{ invoice_number }}
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-lg-4">
                                            <label for="websiteUrl" class="form-label">Issue Date</label>
                                        </div>
                                        <div class="col-lg-8 text-muted">
                                        {{ invoice_issue_date }}
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-lg-4">
                                            <label for="dateInput" class="form-label">Due Date</label>
                                        </div>
                                        <div class="col-lg-8 text-muted">
                                        {{ invoice_due_date }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!--end card-body-->
                        <div class="card-header border-bottom-dashed mb-3 mt-3" style="border-bottom: 1px solid #cfd3d7;">
                        
                            <table class="table table-borderless mb-4" border="1" >
                                <thead>
                                    <tr class="table-active" style="--vz-table-accent-bg: #cfd3d7">
                                        <th class="text-start">#</th>
                                        <th class="text-start col-width">Description</th>
                                        <th class="" style="text-align: center">Amount (RM)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td> 
                                        {{ bil_count(bill)  }}
                                    </td>
                                    <td>{{ invoice_description }}<p style="font-size:11px"><b>{{ invoice_product }}<br>IMEI : {{ invoice_imei }}</b></p></td>
                                    <td class="text-right" style="text-align: right;">{{ invoice_amount ?? invoice_amount.toFixed(2) }}</td>
                                </tr>
                                <tr v-if="parseFloat(invoice_latecharge) > 0">
                                    <td>
                                        {{ bil_count(bill)  }}
                                    </td>
                                    <td>Late Payment Charge</td>
                                    <td class="text-right" style="text-align: right;">{{ invoice_latecharge ?? invoice_latecharge.toFixed(2) }}</td>
                                </tr>

                                <tr v-if="parseFloat(invoice_overpayment) > 0|| parseFloat(credit_note) > 0">
                                    <td colspan="3">
                                        Reduced Amount
                                        <hr>    
                                    </td>
                                </tr>

                                <tr v-if="parseFloat(invoice_overpayment) > 0">
                                    <td>
                                        {{ bil_count(bill)  }}
                                    </td>
                                    <td>Over pay</td>
                                    <td class="text-right" style="text-align: right;">{{ invoice_latecharge ?? invoice_overpayment.toFixed(2) }}</td>
                                </tr>
                                <tr v-if="parseFloat(credit_note) > 0">
                                    <td>
                                        {{ bil_count(bill)  }}
                                    </td>
                                    <td>Credit Note</td>
                                    <td class="text-right" style="text-align: right;">{{ credit_note ?? credit_note.toFixed(2) }}</td>
                                </tr>


                                <tr>
                                    <td></td>
                                    <td style="font-size:17px;text-align: right;"><b>Total Amount (RM) :</b></td>
                                    <td style="font-size:17px;text-align: right;" >{{ (parseFloat(invoice_amount) + parseFloat(invoice_latecharge) - parseFloat(credit_note) - parseFloat(invoice_overpayment)).toFixed(2) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        
                            <div class="mt-3">
                                <h6 class="text-bold text-uppercase fw-semibold mb-5"></h6>
                                <p class="text-muted mb-1"></p>
                                <div clas="row">
                                    <div class="col d-flex align-items-center justify-content-end">
                                        <p class="lead"> <b>
                                        
                                            </b>
                                        </p>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row g-3 justify-content-end p-3">
                            <div class="col-sm-2">
                                <div>
                                    <a :href="invoice_path" target="_blank"  class="btn btn-success w-100">
                                        <i class="ri-printer-line me-2 align-bottom"></i>Print
                                    </a>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div>
                                    <button type="button" @click="downloadPDF" :disabled="downloadLoading" class="btn btn-primary w-100">
                                        <i v-if="downloadLoading" class="ri-loader-4-line me-2 align-bottom"></i>
                                        <i v-if="!downloadLoading"  class="ri-download-2-fill me-2 align-bottom"></i>Download Invoice
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div>
                                    <button type="button" @click="sendEmail" :disabled="emailLoading" class="btn btn-danger w-100">                                        
                                        <i v-if="emailLoading" class="ri-loader-4-line me-2 align-bottom"></i>
                                        <i class="ri-mail-send-fill me-2 align-bottom"></i>
                                        Send Monthly Statement
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <statementOfAccount/>
                </div>
                    <!--end card-body-->
            </div>
                <!--end col-->
            <!-- <div class="container">
            <div class="row">
                <div class="col">
                    <router-link to="/ar/invoice/view/statement-account" tag="button">P2</router-link>

                </div>
            </div>
            </div> -->

           
         
    </Layout>
</template>